import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import ErrorIcon from "/public/images/icons/inputError.svg?react";

const CheckBox = forwardRef(({
  name,
  onChange,
  required,
  label,
  error,
  className,
  ...props
}, ref) => {
  return (
    <label className={`flex flex-col gap-1 ${className}`} data-testid="label">
      <div className="flex flex-row gap-4">
        {label && (
          <div className="label">
            <span className="text-sportsBlack font-semibold text-base leading-[26px] mb-1">
              {label}
              {required && "*"}
            </span>
          </div>
        )}

        <div className="flex flex-row gap-2">
          <div className="relative">
            <input
              name={name}
              onChange={onChange}
              required={required}
              ref={ref}
              {...props}
              type="checkbox"
              className={`
                ${error && "border-sportsRed !border-2"} 
                checked:bg-sportsYellow checked:border-sportsYellow
                peer appearance-none w-[26px] h-[26px] bg-sportsLightGrey border-solid border-[1px] border-[#E3E3E3] rounded-[4px]
              `}
            />
            <div className="bg-[url('/images/icons/checkbox-tick.svg')] bg-center bg-no-repeat bg-[length:13px_10px] absolute w-[26px] h-[26px] top-0 left-0 pointer-events-none rounded-[4px] hidden peer-checked:block"></div>
          </div>

          {error && (
            <span className="cursor-pointer">
              <ErrorIcon className="w-6 h-6" />
            </span>
          )}
        </div>
      </div>

      {error && (
        <p className="text-sportsRed text-base leading-[24px]">{error}</p>
      )}
    </label>
  );
});

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  label: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
};

export default CheckBox;
